import React from 'react'
import herobg from '../../../assets/TransHero.png'
import MobileHeroBg from '../../../assets/TransHeroMobile.png'

const TransvaginalOne = () => {
  return (
    <>
      {/* Desktop/Laptop/Tablet Hero Section */}
      <section className="hidden sm:flex relative w-full min-h-[55vh] md:min-h-[55vh] lg:min-h-[65vh] xl:min-h-[85vh]  items-start justify-center overflow-hidden">
        {/* Background Image */}
        <img
          src={herobg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0  z-10" />

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-6 md:px-16 lg:px-24 py-8 pt-[10vh] md:pt-[12vh] lg:pt-[15vh] text-center
        2xl:max-w-[1990px]
        md:max-w-[675px]
        lg:max-w-[992px]
        ">
          <h1
            className="text-2xl md:text-4xl lg:text-5xl 2xl:text-7xl font-bold text-white mb-4 drop-shadow-lg 2xl:pb-8"
            style={{ fontFamily: 'Quicksand, sans-serif' }}
          >
            Suffered Complications After A Transvaginal Mesh Implant?          </h1>
          <h2
            className="text-sm sm:text-base md:text-s lg:text-xl 2xl:text-3xl text-white mb-6 font-medium drop-shadow leading-relaxed"
            style={{ fontFamily: 'Quicksand, sans-serif' }}
          >
            Thousands of women have reported chronic pain, erosion, and multiple revision surgeries after mesh implants. You may be eligible for legal settlement.          </h2>
        </div>
      </section>
      {/* Mobile Hero Section */}
      <section className="flex sm:hidden relative w-full min-h-[90vh] items-center justify-center overflow-hidden">
        {/* Background Image */}
        <img
          src={MobileHeroBg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
          style={{ minHeight: '90vh', width: '100%' }}
        />
        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-4 text-center">
          <h1
            className="text-white capitalize text-[32px] min-[390px]:text-[40px] min-[500px]:text-[38px] leading-[42px] font-[Quicksand] font-bold -mt-[300px]"
          >
            Suffered Complications After a Transvaginal Mesh Implant?    </h1>
          {/* <h2
      className="text-sm text-white mb-4 font-normal drop-shadow"
      style={{ fontFamily: 'Quicksand, sans-serif' }}
    >
Thousands of women have reported chronic pain, erosion, and multiple revision surgeries after mesh implants. You may be eligible for legal compensation.    </h2> */}
        </div>
        {/* Overlay */}
        <div className="absolute inset-0  z-10" />
      </section>

    </>
  )
}

export default TransvaginalOne
